export const GET_PREFERENCES = 'GET_PREFERENCES';
export const SET_PREFERENCE = 'SET_PREFERENCE';
export const SAVE_PREFERENCES = 'SAVE_PREFERENCES';
